import { style } from "@vanilla-extract/css";
import styles from "plos/src/components/buttons/Button/Button.module.css";
import { breakpoints, vars } from "plos/src/styles";

export const contextualHelpContainer = style({
  position: "sticky",
  zIndex: vars.zIndex.stickyControl,
  insetBlockStart: 0, // stick to the top of the container
  alignSelf: "flex-end",
  height: 0,
});

export const helpSheetContent = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  padding: vars.space.m,
});

export const helpButtonIconContainer = style({
  marginBlockStart: vars.space.l,
  marginInlineEnd: vars.space.m,
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      marginBlockStart: vars.space.xl,
      marginInlineEnd: vars.space.xl,
    },
  },
});

export const helpButtonIcon = style([
  styles.glass,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: vars.borders.outlineVariant,
    borderRadius: vars.radii.full,
    padding: vars.space.m,
    width: 12,
    height: 12,
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.heading.l,
  },
]);
